import styles from './crossError.module.scss';

function CrossError() {
  return (
    <div className={styles.crossError}>
      <img src="images/cross.svg" />
    </div>
  );
}

export default CrossError;
